import React from 'react';

import classes from './forEmployers.module.scss';

export const ForEmployers = () => {
  return (
    <div className={classes.ForEmployers}>
      <div className={classes.ForEmployersSection}>
        <div className={classes.ForEmployersLabel}>For Employers</div>
        <div className={classes.ForEmployersTitle}>
          Better rates. Happier employees. Less admin.
        </div>
        <div className={classes.ForEmployersDescription}>
          With Monark's AI concierge, employers gain access to:
        </div>
        
        <div className={classes.ForEmployersList}>
          <div className={classes.ForEmployersListItem}>
            • Smarter plan design
          </div>
          <div className={classes.ForEmployersListItem}>
            • Seamless administration
          </div>
          <div className={classes.ForEmployersListItem}>
            • Real-time benefits support
          </div>
        </div>

        <div className={classes.ForEmployersOutcome}>
          → Leading to <strong>higher employee satisfaction</strong> with <strong>less HR lift</strong>
        </div>
      </div>
    </div>
  );
};